// store/modules/user.js
import { login, getUserInfo } from '@/api/user'
import { getRouters } from '@/api/menu' // 👈 确保这里引入了真实的 getRouters 接口
import { logout as logoutApi } from '@/api/system'
import { resetRouter } from '@/router'
import Cookies from 'js-cookie'

const state = {
  token: Cookies.get('token') || sessionStorage.getItem('token') || '', 
  userInfo: {}, 
  menuList: [], // 此时存储的将是符合 getRouters 结构的树形菜单数据
  permissions: [] 
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    Cookies.set('token', token)
    sessionStorage.setItem('token', token)
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
    if (userInfo.userId) sessionStorage.setItem('userid', userInfo.userId)
    if (userInfo.username) sessionStorage.setItem('username', userInfo.username)
  },
  SET_MENU_LIST: (state, menuList) => {
    state.menuList = menuList
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  LOGOUT: (state) => {
    state.token = ''
    state.userInfo = {}
    state.menuList = []
    state.permissions = []
    Cookies.remove('token')
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('userid')
    sessionStorage.removeItem('username')
    resetRouter()
  }
}

const actions = {
  Login({ commit }, userForm) {
    const { username, password } = userForm
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password })
        .then(res => {
          if ([200, 0].includes(res.code)) {
            const token = res.data['access_token'] || res.data.token
            commit('SET_TOKEN', token)
            resolve()
          } else {
            reject(new Error(res.msg))
          }
        })
        .catch(error => { reject(error) })
    })
  },

  // 获取用户信息 + 真实的路由菜单树
  GetUserInfoAndMenu({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfo(state.token)
        .then(res => {
          const userInfo = res.data
          commit('SET_USER_INFO', userInfo)
          
          // 获取并存入按钮级别权限（通常在 userInfo.permissions 中）
          const userPermissions = userInfo.permissions || []
          commit('SET_PERMISSIONS', userPermissions)
          
          // 👈 核心修改：调用真正的树形路由接口
          return getRouters()
        })
        .then(res => {
          const routerTree = res.data || []
          // 存入 Vuex 供左侧侧边栏组件进行渲染
          commit('SET_MENU_LIST', routerTree)
          resolve(routerTree)
        })
        .catch(error => { reject(error) })
    })
  },

  Logout({ commit }) {
    return new Promise((resolve) => {
      const doLogout = async () => {
        try { await logoutApi() } catch (err) { console.error(err) } finally {
          commit('LOGOUT')
          resolve()
        }
      }
      doLogout()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    menuList: state => state.menuList,
    permissions: state => state.permissions
  }
}
